import React from "react";
import {
  Box,
  FormHelperText,
  InputLabel,
  OutlinedInput,
  SxProps,
  Theme,
} from "@mui/material";

import { isValidString } from "Utils/validators";
import { Colors } from "Utils/colors";

interface IProps {
  forwardedRef?: any;
  label?: string;
  placeholder?: string;
  value: string | any;
  onChangeText: (value: string) => void;
  handleBlur?: (e: any) => void;
  onSubmitEditing?: () => void;
  editable?: boolean;
  isError: boolean | undefined | any;
  errorMessage: string;
  required: boolean;
  size: "small" | "medium";
  containerStyle?: SxProps<Theme> | undefined;
  inputClassName?: string;
  type?: "text" | "email" | "password" | "number";
  endAdornment?: React.ReactNode;
  labelStyle?: any | undefined;
  handleOnClick?: () => void;
  maxLength?: number;
  disabled?: boolean;
  readOnly?: boolean; // Add readOnly prop here
}

export const CustomInputComponent = (props: IProps) => {
  const {
    errorMessage,
    isError,
    handleBlur,
    onChangeText,
    onSubmitEditing,
    value,
    editable,
    label,
    placeholder,
    forwardedRef,
    required,
    size,
    containerStyle,
    inputClassName,
    type,
    endAdornment,
    labelStyle,
    handleOnClick,
    maxLength,
    disabled,
    readOnly,
  } = props;

  return (
    <Box sx={{ marginTop: 2, ...containerStyle }}>
      {isValidString(label) ? (
        <InputLabel
          sx={(theme) => ({
            fontSize: 12,
            color: isError ? theme.palette.error.main : Colors.textColor,
            fontWeight: 700,
            marginBottom: 0.5,
            ...labelStyle,
          })}
        >
          {label}
        </InputLabel>
      ) : null}
      <OutlinedInput
        sx={{ fontSize: 11 }}
        type={type}
        size={size}
        margin="none"
        required={required}
        fullWidth
        ref={forwardedRef}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChangeText(e.target.value)}
        onBlur={handleBlur}
        error={isError}
        className={inputClassName}
        onSubmit={onSubmitEditing && onSubmitEditing}
        endAdornment={endAdornment}
        onClick={handleOnClick && handleOnClick}
        inputProps={maxLength ? { maxLength: maxLength } : {}}
        disabled={disabled}
        readOnly={readOnly}
      />
      {isError ? <FormHelperText error>{errorMessage}</FormHelperText> : null}
    </Box>
  );
};

CustomInputComponent.defaultProps = {
  type: "text",
  readOnly: false,
};
